import React from 'react'
import { View, StyleSheet, ViewStyle, StyleProp } from 'react-native'

interface CardProps {
  children: React.ReactNode
  style?: StyleProp<ViewStyle>
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
  }
})

export const Card: React.FC<CardProps> = ({ children, style }) => {
  return (
    <View style={[styles.card, style]}>
      {children}
    </View>
  )
}